import { CardContent, Typography } from '@mui/material';
import React from 'react';

function ShowErrorMessage({ message }) {
  return (
    <div
      style={{
        width: '100%',
        marginTop: '15px',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: '#EA5455',
      }}
    >
      {' '}
      <CardContent>
        <Typography variant="body1" style={{ color: 'white' }}>
          {message}
        </Typography>
      </CardContent>
    </div>
  );
}
export function ShowSuccess({ message }) {
  return (
    <div
      style={{
        width: '100%',
        marginTop: '15px',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: '#28C76F',
      }}
    >
      <CardContent>
        <Typography variant="body1" style={{ color: 'white' }}>
          {message}
        </Typography>
      </CardContent>
    </div>
  );
}

export default ShowErrorMessage;
